"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intl = require("@kyruus/intl");
var _button = _interopRequireDefault(require("@kyruus/button"));
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _api = require("../../lib/api");
var _loadScript = _interopRequireDefault(require("load-script"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function RecaptchaModal(_ref) {
  let {
    onCancel,
    onVerified,
    onError,
    siteKey,
    customerCode,
    intl
  } = _ref;
  const [grecaptchaLoaded, setGrecaptchaLoaded] = (0, _react.useState)(false);
  const containerRef = (0, _react.useRef)();
  const onGrecaptchaReady = (0, _react.useCallback)(() => {
    setGrecaptchaLoaded(true);
    window.grecaptcha.render(containerRef.current, {
      sitekey: siteKey,
      callback: async response => {
        try {
          const data = await new _api.Api(customerCode).postCaptchaResponseToken(response);
          if (data.verified) {
            onVerified(data.verified);
          } else {
            onError();
          }
        } catch (e) {
          onError(e);
        }
      }
    });
    // skip dependency checks to enforce this hook running only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(() => {
    if (typeof window.grecaptcha === 'object') {
      window.grecaptcha.ready(onGrecaptchaReady);
    } else {
      (0, _loadScript.default)('https://www.google.com/recaptcha/api.js?render=explicit', err => {
        if (!err) {
          window.grecaptcha.ready(onGrecaptchaReady);
        }
      });
    }
  }, [onGrecaptchaReady]);
  const modalBody = grecaptchaLoaded ? /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "RecaptchaLoaded",
    ref: containerRef
  }) : /*#__PURE__*/_react.default.createElement(_styles.LoadingContainer, {
    "data-testid": "LoadingGrecaptcha"
  }, /*#__PURE__*/_react.default.createElement(_styles.LoadingCell, null));
  return /*#__PURE__*/_react.default.createElement(_styles.Modal, {
    "data-testid": "Recaptcha",
    title: intl.formatMessage(_messages.default.interruptionapology),
    subtitle: intl.formatMessage(_messages.default.notrobot),
    open: true,
    useHeaderBorder: false,
    maxWidth: "md",
    body: modalBody,
    onClose: onCancel,
    primaryButton: /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: onCancel
    }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.cancel))
  });
}
RecaptchaModal.propTypes = {
  onCancel: _propTypes.default.func.isRequired,
  /** callback for when captcha response is verified correctly against the API */
  onVerified: _propTypes.default.func.isRequired,
  /** callback when recaptcha validation encounters an error from the API */
  onError: _propTypes.default.func.isRequired,
  siteKey: _propTypes.default.string.isRequired,
  customerCode: _propTypes.default.string.isRequired,
  // provided via `injectIntl`
  intl: _propTypes.default.object.isRequired
};
var _default = exports.default = (0, _intl.injectIntl)(RecaptchaModal);
RecaptchaModal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RecaptchaModal",
  "props": {
    "onCancel": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onVerified": {
      "description": "callback for when captcha response is verified correctly against the API",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onError": {
      "description": "callback when recaptcha validation encounters an error from the API",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "siteKey": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "customerCode": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    }
  }
};